// ABOUTME: Defines the canonical User form policy for branch access controls.
// ABOUTME: Hides branch fields and removes them from canonical User submissions.
import { filterHiddenFormMetadata } from "customHooks/useCompleoForm/components/formMetadataVisibility";

export const USER_BRANCH_ACCESS_FIELDS = [
    "allBranchAccess",
    "accessVacanciesWithoutBranch",
    "BranchsAccessList"
] as const;

export const getUserFormFieldsToHide = (): string[] => [
    ...USER_BRANCH_ACCESS_FIELDS
];

export const stripUserBranchAccessFields = <T extends Record<string, any>>(
    values: T
): Omit<T, (typeof USER_BRANCH_ACCESS_FIELDS)[number]> => {
    const sanitized = { ...values } as T &
        Partial<Record<(typeof USER_BRANCH_ACCESS_FIELDS)[number], unknown>>;

    USER_BRANCH_ACCESS_FIELDS.forEach((field) => {
        delete sanitized[field];
    });

    return sanitized as Omit<T, (typeof USER_BRANCH_ACCESS_FIELDS)[number]>;
};

export const stripUserBranchAccessMetadata = <T extends { response?: any }>(
    metadata: T
): T => {
    const response = metadata?.response;
    const data = response?.data;
    if (!Array.isArray(data?.metadado)) return metadata;

    return {
        ...metadata,
        response: {
            ...response,
            data: {
                ...data,
                metadado: filterHiddenFormMetadata(
                    data.metadado,
                    USER_BRANCH_ACCESS_FIELDS
                )
            }
        }
    } as T;
};
